module.exports = __webpack_public_path__ + "img/app.3e4a0c2b.png";